import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { getStoryById } from '../services/api';
import { Clock, Calendar, ArrowLeft } from 'lucide-react';

const StoryDetail = () => {
  const { category, id } = useParams();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchStory = async () => {
      try {
        const data = await getStoryById(id);
        if (data.category === category) {
          setStory(data);
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error('Error fetching story:', error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    
    fetchStory();
    window.scrollTo(0, 0);
  }, [id, category]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  if (notFound || !story) {
    return <Navigate to="/" replace />;
  }

  const formattedDate = new Date(story.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="py-16 px-6">
      <article className="max-w-3xl mx-auto">
        <Link
          to={`/${category}`}
          className="inline-flex items-center gap-2 text-sm uppercase tracking-wider text-gray-600 hover:text-gray-900 transition-colors duration-200 mb-8"
        >
          <ArrowLeft size={16} />
          Back to {category}
        </Link>

        <header className="mb-12">
          <h1 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6 leading-tight">
            {story.title}
          </h1>
          
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <span className="flex items-center gap-2">
              <Calendar size={16} />
              {formattedDate}
            </span>
            <span className="flex items-center gap-2">
              <Clock size={16} />
              {story.readTime}
            </span>
          </div>
        </header>

        <div className="prose prose-lg max-w-none">
          {story.content.split('\n\n').map((paragraph, index) => (
            <p key={index} className="text-gray-800 leading-relaxed mb-6">
              {paragraph}
            </p>
          ))}
        </div>

        <footer className="mt-16 pt-8 border-t border-gray-200">
          <Link
            to={`/${category}`}
            className="inline-flex items-center gap-2 text-sm uppercase tracking-wider text-gray-900 hover:text-gray-600 transition-colors duration-200"
          >
            <ArrowLeft size={16} />
            Back to {category}
          </Link>
        </footer>
      </article>
    </div>
  );
};

export default StoryDetail;